var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-page"},[_c('div',[_c('adv-title',[_vm._v("Task")]),_c('h1',[_c('i',[_vm._v(_vm._s(_vm.task))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }